<template>
  <Card :title="$t('global.local-mail-delivery')">
    <CardToggle
      :label="`${$t('global.enable')}:`"
      :description="$t('global.local-delivery-description')"
    >
      <template #toggle>
        <Toggle
          @change="onToggle"
          :value="localMailDeliveryEnabled"
          :transitioning="localMailDeliveryStatus.isLoading || loading"
        />
      </template>
    </CardToggle>
  </Card>
</template>

<script>
import Card from "@/components/display/Card";
import CardToggle from "@/components/display/card-sub-components/CardToggle";
import { computed } from "@vue/composition-api";
import LocalMailDeliveryDisableModal from "@/components/smart/modals/LocalMailDeliveryDisable";
import LocalMailDeliveryEnableModal from "@/components/smart/modals/LocalMailDeliveryEnable";
import store from "@/store";
import Toggle from "@/components/display/Toggle";

export default {
  name: "LocalMailDelivery",
  components: { Card, CardToggle, Toggle },
  props: {
    site: {
      type: Object,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const localMailDeliveryStatus = computed(() => store.state.emailBoxes.localMailDeliveryStatus);
    const localMailDeliveryEnabled = computed(
      () => store.state.emailBoxes.localMailDeliveryEnabled
    );

    const enableLocalMail = () => {
      store.dispatch("emailBoxes/setLocalMailDelivery", true);
      store.dispatch("modals/open", {
        template: LocalMailDeliveryEnableModal,
        close: () => {
          store.dispatch("emailBoxes/setLocalMailDelivery", false);
        },
        data: {
          site: props.site,
        },
      });
    };

    const disableLocalMail = () => {
      store.dispatch("emailBoxes/setLocalMailDelivery", false);
      store.dispatch("modals/open", {
        template: LocalMailDeliveryDisableModal,
        close: () => {
          store.dispatch("emailBoxes/setLocalMailDelivery", true);
        },
        data: {
          site: props.site,
        },
      });
    };

    const onToggle = () => {
      if (!localMailDeliveryEnabled.value) {
        enableLocalMail();
      } else {
        disableLocalMail();
      }
    };

    return {
      onToggle,
      localMailDeliveryEnabled,
      localMailDeliveryStatus,
    };
  },
};
</script>
